import * as index from '@syncfusion/ej2-lists';
index.ListView.Inject( index.Virtualization);
export * from '@syncfusion/ej2-lists';
